export default __webpack_public_path__ + "63c916b435cb82cea875a079acac2a88.png";